module.exports = __webpack_public_path__ + "static/media/Instructions-after-trial.3071eebb.mp3";